<template>
	<div class="c-faq">
		<h2>Frequently asked questions</h2>
		<ul>
			<li>
				<h4>How to select multiple notes?</h4>
				<p>
					Inside the list, click on the purple checkbox next to any highlight to
					select multiple highlights.
				</p>
				<p>
					Then click on the 'Export note' button. This will open a windows with
					those highlights formatted and grouped by their domain.
				</p>
			</li>
			<li>
				<h4>How do I turn the highlighter off?</h4>
				<p>Press <span class="hotkey">Alt+S</span> to toggle the highlighter</p>
			</li>
		</ul>
	</div>
</template>

<script>
export default {};
</script>

<style lang="scss">
.c-faq {
	.hotkey {
		font-family: monospace;
		font-size: 1rem;
		font-weight: 500;
		padding: 3px 6px;
		background-color: rgba(255, 255, 255, 0.1);
		border-radius: 3px;
	}
}
</style>